import React, { Component } from 'react';
import Navigation from './components/Navigation/Navigation'
import './App.css';
import './bootstrap.css';
import { Provider } from 'react-redux';
import Router from './Router.js'
import store from './store';
import AuthApp from './components/AuthApp'
import Startup from "./Startup/Startup";
import { initializeIcons, loadTheme } from '@fluentui/react';
import ErrorBoundary from "./ErrorBoundary/ErrorBoundary";
import { setAppHost } from './actions/appActions';
import * as microsoftTeams from "@microsoft/teams-js";
import MessageBars from './MessageBars';

loadTheme({
    defaultFontStyle: {
        fontFamily: 'Abb Inside'
    }
});

store.dispatch(setAppHost());
const state = store.getState();

if (state.app.isMsTeamsApp) {
  microsoftTeams.initialize(() => {
    microsoftTeams.getContext(context => {
      if (context.subEntityId) {
        document.location.hash = context.subEntityId;
      }
    });
  });
}

class App extends Component {

  render() {
    initializeIcons(/* optional base url */);

    return (
      <Provider store={store}>
        <div>
            <ErrorBoundary>
              <AuthApp>
                <Startup>
                  { !state.app.isMsTeamsApp && <Navigation /> }
                  <MessageBars />
                  <div className='base-page'>
                    <Router />
                  </div>
                </Startup>
              </AuthApp>
            </ErrorBoundary>
        </div>
      </Provider>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js